// removed by extract-text-webpack-plugin
module.exports = {"root":"root_3HRkB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InlineLink/style.css
// module id = 185
// module chunks = 0